<div class="page-wrapper">
  <div class="blob blob-main"></div>
  <div class="blob blob-small"></div>
  <div class="blob blob-accent"></div>

  <div class="page-container">

    <!-- Header -->
    <header class="top-nav">
      <div class="hero-logo">
        <img
          src="../../assets/images/Logo.svg"
          alt="Nishwik Logo"
          class="img-fluid"
        />
      </div>
    </header>

    <!-- Main -->
    <main class="main-content">

      <!-- Left Panel -->
      <section class="left-panel">
        <span class="badge">Society Management Platform</span>

        <h1 class="headline">
          Society Living.<br /><span class="accent">Streamlined.</span>
        </h1>

        <p class="lead">
          Manage maintenance billing, member records, complaints, visitor entry,
          notices, and society accounts — all from one connected platform built
          for modern housing societies.
        </p>

        <div class="feature-grid">
          <div class="feature-card">
            <div class="ficon ic-1">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M3 21h18M5 21V7l8-4v18M19 21V11l-6-4"/>
              </svg>
            </div>
            <div>
              <h3>Maintenance</h3>
              <p>Billing &amp; collections</p>
            </div>
          </div>
          <div class="feature-card">
            <div class="ficon ic-2">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </div>
            <div>
              <h3>Members</h3>
              <p>Records &amp; directory</p>
            </div>
          </div>
          <div class="feature-card">
            <div class="ficon ic-3">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
            </div>
            <div>
              <h3>Complaints</h3>
              <p>Tickets &amp; tracking</p>
            </div>
          </div>
          <div class="feature-card">
            <div class="ficon ic-4">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM3 20a6 6 0 0 1 12 0M16 3.13a4 4 0 0 1 0 7.75M21 21v-2a4 4 0 0 0-3-3.87"/>
              </svg>
            </div>
            <div>
              <h3>Visitors</h3>
              <p>Gate &amp; entry log</p>
            </div>
          </div>
        </div>
      </section>

      <!-- Right: Login Card -->
      <section class="right-panel">
        <div class="login-card">
          <h2 class="card-title">Welcome Back</h2>

          <!-- Password Login -->
          <form *ngIf="!isMobileLogin" [formGroup]="loginForm" (ngSubmit)="onLogin()">
            <div class="field">
              <label for="username">Username / Email</label>
              <input
                type="text"
                id="username"
                placeholder="Enter username"
                formControlName="username"
                [class.error]="loginForm.get('username')?.invalid && loginForm.get('username')?.touched"
              />
              <span class="field-error" *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched">
                Username is required.
              </span>
            </div>

            <div class="field">
              <label for="password">Password</label>
              <div class="input-wrap">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  id="password"
                  placeholder="Enter password"
                  formControlName="password"
                  [class.error]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
                />
                <button type="button" class="toggle-eye" (click)="togglePassword()">
                  <svg *ngIf="!showPassword" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                  </svg>
                  <svg *ngIf="showPassword" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                </button>
              </div>
              <span class="field-error" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
                Password is required.
              </span>
            </div>

            <label class="remember">
              <input type="checkbox" formControlName="rememberMe" /> Remember me
            </label>

            <button
              type="submit"
              class="btn-signin"
              [disabled]="loginForm.invalid || loading"
              [class.loading]="loading"
            >
              <span class="btn-text">Sign In</span>
            </button>
          </form>

          <!-- Mobile OTP: Enter Number -->
          <form *ngIf="isMobileLogin && !isOtpSent" [formGroup]="mobileForm" (ngSubmit)="sendOtp()">
            <div class="field">
              <label for="mobileNo">Mobile Number</label>
              <input
                type="tel"
                id="mobileNo"
                placeholder="Enter 10-digit number"
                formControlName="mobileNo"
                [class.error]="mobileForm.get('mobileNo')?.invalid && mobileForm.get('mobileNo')?.touched"
              />
              <span class="field-error" *ngIf="mobileForm.get('mobileNo')?.invalid && mobileForm.get('mobileNo')?.touched">
                Enter a valid 10-digit mobile number.
              </span>
            </div>
            <button type="submit" class="btn-signin" [disabled]="mobileForm.invalid || loading" [class.loading]="loading">
              <span class="btn-text">Send OTP</span>
            </button>
          </form>

          <!-- Mobile OTP: Verify -->
          <div *ngIf="isOtpSent">
            <p class="otp-hint">{{ maskedMessage }}</p>
            <form [formGroup]="otpForm" (ngSubmit)="verifyOtp()">
              <div class="otp-boxes">
                <input id="otp1" maxlength="1" class="otp-input" formControlName="otp1" (input)="onOtpInput($event, 1)" (keydown)="onOtpKeydown($event, 1)" />
                <input id="otp2" maxlength="1" class="otp-input" formControlName="otp2" (input)="onOtpInput($event, 2)" (keydown)="onOtpKeydown($event, 2)" />
                <input id="otp3" maxlength="1" class="otp-input" formControlName="otp3" (input)="onOtpInput($event, 3)" (keydown)="onOtpKeydown($event, 3)" />
                <input id="otp4" maxlength="1" class="otp-input" formControlName="otp4" (input)="onOtpInput($event, 4)" (keydown)="onOtpKeydown($event, 4)" />
                <input id="otp5" maxlength="1" class="otp-input" formControlName="otp5" (input)="onOtpInput($event, 5)" (keydown)="onOtpKeydown($event, 5)" />
                <input id="otp6" maxlength="1" class="otp-input" formControlName="otp6" (input)="onOtpInput($event, 6)" (keydown)="onOtpKeydown($event, 6)" />
              </div>

              <div class="otp-meta">
                <span class="timer" *ngIf="timerSeconds > 0">{{ timerSeconds }}s remaining</span>
                <span class="timer inactive" *ngIf="timerSeconds === 0">OTP expired</span>
                <a class="resend-link" [class.disabled]="resendOtpDisabled" (click)="!resendOtpDisabled && resendOtp()">
                  Resend OTP
                </a>
              </div>

              <button type="submit" class="btn-signin" [disabled]="otpForm.invalid || loading" [class.loading]="loading">
                <span class="btn-text">Verify &amp; Login</span>
              </button>

              <div class="change-no-wrap">
                <a class="change-no" (click)="changeMobileNo()">← Change Mobile Number</a>
              </div>
            </form>
          </div>

          <!-- Toggle login mode -->
          <div class="divider">
            <span class="divider-line"></span>
            <span class="divider-text">OR</span>
            <span class="divider-line"></span>
          </div>

          <button type="button" class="btn-otp" (click)="toggleLoginMode()">
            {{ isMobileLogin ? 'Login with Password' : 'Login via OTP' }}
          </button>
        </div>
      </section>

    </main>
  </div>

  <!-- Footer -->
  <footer class="bottom-bar">
    <div class="foot-inner">
      <span class="copyright">© 2026 Nishwik Society OS. All rights reserved.</span>
      <div class="foot-links">
        <a routerLink="/policy/privacy">Privacy Policy</a>
        <a routerLink="/policy/terms">Terms &amp; Conditions</a>
        <a routerLink="/policy/cancellation">Cancellation Policy</a>
        <a routerLink="/policy/refund">Refund Policy</a>
        <a routerLink="/policy/contact">Contact us</a>
      </div>
    </div>
  </footer>
</div>